<template>
  <th>
    <slot />
  </th>
</template>

<script>
export default {
  name: 'dx-th',
};
</script>

<style scoped lang="scss">
th {
  padding: calc(var(--dx-space-size--md) - var(--dx-space-size--xs)) var(--dx-space-size--md);
}
</style>
